import { render, staticRenderFns } from "./ui-news-bar.component.vue?vue&type=template&id=6f3bcf61&"
import script from "./ui-news-bar.component.vue?vue&type=script&lang=ts&"
export * from "./ui-news-bar.component.vue?vue&type=script&lang=ts&"
import style0 from "./ui-news-bar.component.vue?vue&type=style&index=0&id=6f3bcf61&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports